import React from 'react'

export default function ErrorField({children}) {
  return (
    <div className="invalid-feedback d-block">{children}</div>
  )
}
